import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-24 px-4 bg-foreground">
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-display-md font-bold text-primary-foreground mb-4">
            See Where You're Losing Leads
          </h2>
          <p className="text-lg text-primary-foreground/70 mb-10 leading-relaxed">
            Get a free audit of your funnel, follow-ups, and conversion system.
          </p>
          <Link to="/contact">
            <Button
              size="lg"
              className="px-10 py-6 text-base font-semibold bg-primary hover:bg-primary/90 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Get My Free Audit
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
